import { AccessLevel } from '../../../../types';

export interface GetAccessLevelOptionsParams {
    isWaitingRoomEnabled: boolean;
    canUseBackendAccessLevels: boolean;
    availableAccessLevels?: AccessLevel[];
}

const ALL_WAITING_ROOM_LEVELS: AccessLevel[] = [AccessLevel.ADMINS, AccessLevel.ORGANIZATION, AccessLevel.PUBLIC];

export function getAccessLevelOptions(params: GetAccessLevelOptionsParams): AccessLevel[] {
    const { isWaitingRoomEnabled, canUseBackendAccessLevels, availableAccessLevels } = params;

    if (canUseBackendAccessLevels) {
        if (!availableAccessLevels?.length) {
            return [];
        }

        if (isWaitingRoomEnabled) {
            return availableAccessLevels;
        }

        const hasOrganizationLevel = availableAccessLevels.includes(AccessLevel.ORGANIZATION);

        return hasOrganizationLevel
            ? availableAccessLevels.filter((level) => level !== AccessLevel.ADMINS)
            : availableAccessLevels;
    }

    if (isWaitingRoomEnabled) {
        return ALL_WAITING_ROOM_LEVELS;
    }

    return [AccessLevel.ORGANIZATION, AccessLevel.PUBLIC];
}
